class BionyProduct extends HTMLElement {
  connectedCallback() {
    this.idInput = this.querySelector('form [name="id"]');
    this.priceEl = this.querySelector('[data-mp-price]');
    this.compareEl = this.querySelector('[data-mp-compare]');
    this.offEl = this.querySelector('[data-mp-off]');
    this.totalEl = this.querySelector('[data-mp-total]');

    this.querySelectorAll('input[name="biony-bundle"]').forEach((input) => {
      input.addEventListener('change', () => this.select(input));
    });
  }

  select(input) {
    if (this.idInput) this.idInput.value = input.value;
    const { price, compare, off } = input.dataset;
    if (this.priceEl) this.priceEl.textContent = price;
    if (this.totalEl) this.totalEl.textContent = price;
    if (this.compareEl) {
      this.compareEl.textContent = compare || '';
      this.compareEl.hidden = !compare;
    }
    if (this.offEl) {
      this.offEl.textContent = off ? `${off}% OFF` : '';
      this.offEl.hidden = !off;
    }
  }
}

if (!customElements.get('biony-product')) {
  customElements.define('biony-product', BionyProduct);
}

class BionyGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    // Índice de slide del primer thumb: 0 si el slider salta la lata, 1 si no.
    this.thumbOffset = Number(this.dataset.thumbOffset || 0);
    if (!this.track) return;

    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const slide = this.track.children[i + this.thumbOffset];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.setActive(0);
  }

  onScroll() {
    if (this.raf) return;
    this.raf = requestAnimationFrame(() => {
      this.raf = null;
      this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth));
    });
  }

  setActive(slideIndex) {
    this.thumbs.forEach((thumb, i) => {
      thumb.setAttribute('aria-current', i + this.thumbOffset === slideIndex ? 'true' : 'false');
    });
  }
}

if (!customElements.get('biony-gallery')) {
  customElements.define('biony-gallery', BionyGallery);
}
